import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home/Home'
import Signin from '@/components/Signin'
import Signup from '@/components/Signup'
import CreateSurveyGroup from '@/components/SurveyGroup/CreateSurveyGroup'
import SurveyGroupList from '@/components/SurveyGroup/SurveyGroupList'
import AssignSurvey from '@/components/SurveyGroup/AssignSurvey'
import CreateSurvey from '@/components/Survey/CreateSurvey'
import User from '@/components/User/User'
import CreateUser from '@/components/User/CreateUser'
import UpdateUser from '@/components/User/UpdateUser'
import UploadUser from '@/components/User/UploadUserData'
import UserList from '@/components/User/UserList'
import AssignDummyUser from '@/components/User/AssignDummyUser'
import Result from '@/components/Result/Result'
import Question from '@/components/Questions/CreateQuestion'
import WelcomeMail from '@/components/WelcomeMail/WelcomeMail'
import Campus from '@/components/Campus/Campus'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/dashboard',
      name: 'Home',
      component: Home
    },
    {
      path: '/createuser',
      name: 'CreateUser',
      component: CreateUser
    },
    {
      path: '/updateuser',
      name: 'UpdateUser',
      component: UpdateUser
    },
    {
      path: '/uploaduser',
      name: 'UploadUser',
      component: UploadUser
    },
    {
      path: '/assigndummyuser',
      name: 'AssignDummyUser',
      component: AssignDummyUser
    },
    {
      path: '/Signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/assignsurvey',
      name: 'AssignSurvey',
      component: AssignSurvey
    },
    {
      path: '/surveygroupslist',
      name: 'SurveyGroupList',
      component: SurveyGroupList
    },
    {
      path: '/createsurveygroup',
      name: 'CreateSurveyGroup',
      component: CreateSurveyGroup
    },
    {
      path: '/createsurvey',
      name: 'CreateSurvey',
      component: CreateSurvey
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    {
      path: '/userlist',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/result',
      name: 'Result',
      component: Result
    },
    {
      path: '/question',
      name: 'Question',
      component: Question
    },
    {
      path: '/welcomemail',
      name: 'WelcomeMail',
      component: WelcomeMail
    },
    {
      path: '/campus',
      name: 'Campus',
      component: Campus
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.name !== 'Signin' && !window.localStorage.getItem('hashed-entities')) {
    next({name: 'Signin'})
  } else if (to.name === 'Signin' && window.localStorage.getItem('hashed-entities')) {
    next({name: 'CreateUser'})
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js